import { inject, Injectable } from '@angular/core';
import { CryptoUtilsService } from 'src/app/shared/services/crypto-utils.service';
import { WebsocketParams } from './websocket-params';
import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';
import { MemberType } from './member-type';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';

@Injectable({
  providedIn: 'root',
})
export class ModeratorWebsocketParamsService {
  public static readonly MODERATOR_SESSION_KEY = 'moderator-session-id';
  public static readonly MODERATOR_MEMBER_ID_KEY = 'moderator-member-id';

  companyStateService = inject(CompanyStateService);
  crypto = inject(CryptoUtilsService);
  localStoreService = inject(LocalStorageHelperService);

  create(
    memberDisplayName: ModeratorWebsocketParams['memberDisplayName'],
    displayId: ModeratorWebsocketParams['displayId'],
    displayIds: ModeratorWebsocketParams['displayIds'],
    token: ModeratorWebsocketParams['token'],
    sessionId: ModeratorWebsocketParams['sessionId'],
    existingSession: ModeratorWebsocketParams['existingSession'],
  ): ModeratorWebsocketParams {
    return new ModeratorWebsocketParams(
      memberDisplayName,
      displayId,
      displayIds,
      token,
      sessionId,
      existingSession,
      this.getMemberId(),
    );
  }

  private getMemberId() {
    let memberId = this.localStoreService.get(
      ModeratorWebsocketParamsService.MODERATOR_MEMBER_ID_KEY,
    );
    if (memberId) {
      return memberId;
    }

    memberId = this.crypto.randomUUID();
    this.localStoreService.set(
      ModeratorWebsocketParamsService.MODERATOR_MEMBER_ID_KEY,
      memberId,
    );
    return memberId;
  }
}

class ModeratorWebsocketParams implements Pick<
  WebsocketParams,
  | 'memberType'
  | 'memberDisplayName'
  | 'displayId'
  | 'displayIds'
  | 'token'
  | 'sessionId'
  | 'memberId'
  | 'existingSession'
> {
  memberType: Required<WebsocketParams>['memberType'] = MemberType.MODERATOR;

  constructor(
    public memberDisplayName: Required<WebsocketParams>['memberDisplayName'],
    public displayId: WebsocketParams['displayId'],
    public displayIds: WebsocketParams['displayIds'],
    public token: WebsocketParams['token'],
    public sessionId: Required<WebsocketParams>['sessionId'],
    public existingSession: Required<WebsocketParams>['existingSession'],
    public memberId: Required<WebsocketParams>['memberId'],
  ) {}

  asQueryParams() {
    const urlParams = new URLSearchParams();
    urlParams.append('memberType', this.memberType);
    urlParams.append('memberDisplayName', this.memberDisplayName);
    urlParams.append('sessionId', this.sessionId);
    urlParams.append('memberId', this.memberId);
    if (this.displayId) urlParams.append('displayId', this.displayId);
    if (this.displayIds?.length)
      urlParams.append('displayIds', this.displayIds.join(','));
    if (this.token) urlParams.append('token', `Bearer ${this.token}`);
    if (this.existingSession)
      urlParams.append('existingSession', this.existingSession.toString());
    return urlParams.toString();
  }

  isModerator() {
    return true;
  }
}
